import Icon from '../../components/Icon.vue'

Icon.register({"regular/window-close":{"width":512,"height":512,"paths":[{"d":"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM464 426C464 429.3 461.3 432 458 432H54C50.7 432 48 429.3 48 426V86C48 82.7 50.7 80 54 80H458C461.3 80 464 82.7 464 86V426zM356.5 194.6L295.1 256 356.5 317.4C361.1 322 361.1 329.5 356.5 334.2L334.2 356.5C329.6 361.1 322.1 361.1 317.4 356.5L256 295.1 194.6 356.5C190 361.1 182.5 361.1 177.8 356.5L155.5 334.2C150.9 329.6 150.9 322.1 155.5 317.4L216.9 256 155.5 194.6C150.9 190 150.9 182.5 155.5 177.8L177.8 155.5C182.4 150.9 189.9 150.9 194.6 155.5L256 216.9 317.4 155.5C322 150.9 329.5 150.9 334.2 155.5L356.5 177.8C361.2 182.4 361.2 189.9 356.5 194.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-close.js
// module id = S65u
// module chunks = 0